import React, { useEffect } from "react";
import { CheckCircle2, X, XCircle } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../../store/hook";
import { dismissToast } from "../../../features/rbac/RBACSlice";

const TOAST_TTL_MS = 4500;

export const RBACToasts: React.FC = () => {
  const dispatch = useAppDispatch();
  const toasts = useAppSelector((s) => s.rbac.toasts);

  useEffect(() => {
    if (toasts.length === 0) return;
    const timers = toasts.map((t) =>
      window.setTimeout(() => dispatch(dismissToast(t.id)), TOAST_TTL_MS)
    );
    return () => {
      timers.forEach((id) => window.clearTimeout(id));
    };
  }, [toasts, dispatch]);

  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none fixed right-6 top-6 z-[60] flex w-full max-w-sm flex-col gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`pointer-events-auto flex items-start gap-3 rounded-md border bg-white px-4 py-3 shadow-md ${
            t.kind === "success"
              ? "border-emerald-200"
              : "border-red-200"
          }`}
        >
          {t.kind === "success" ? (
            <CheckCircle2 className="mt-0.5 h-5 w-5 text-emerald-600" />
          ) : (
            <XCircle className="mt-0.5 h-5 w-5 text-red-600" />
          )}
          <div className="flex-1 text-sm text-gray-800">{t.message}</div>
          <button
            type="button"
            onClick={() => dispatch(dismissToast(t.id))}
            className="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
            aria-label="Dismiss notification"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
};
